module.exports = __webpack_public_path__ + "static/media/paypal.80494044.svg";